import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Router } from '@angular/router';

const BASE_PATH = environment.basePath;
const PREFIX = environment.prefix;
const ACCESS_TOKEN = `${PREFIX}_access_token`;
const REFRESH_TOKEN = `${PREFIX}_refresh_token`;
const REFRESH_SERVICE = `${BASE_PATH}/security/refreshToken`;
const LOGIN_SERVICE = `${BASE_PATH}/security/authenticate`;
const LOGOUT_SERVICE = `${BASE_PATH}/security/logout`;

import { MsalService } from '@azure/msal-angular';
import { SessionService } from '@app/custom-shared/services/session-service/session.service';

@Injectable({
  providedIn: 'root',
})

/**
 * Represents the refresh token management service
 */
export class RefreshTokenService {
  constructor(
    public router: Router, 
    private msalService: MsalService,
    private sessionService: SessionService
    ) {}

  /**
   * Returns the refresh token from the local storage
   * @returns {string} the refresh token
   */
  refreshTokenGetter(): string {
    return localStorage.getItem(REFRESH_TOKEN);
  }
  /**
   * Stores the access token and the refresh token if enabled
   * in the local storage
   */
  refreshTokenSetter(res: any): boolean {
    if (res) {
      if (!res['token']) {
        this.clearStorage();
        return false;
      }
      localStorage.setItem(ACCESS_TOKEN, res['token']);
      if (res['refreshToken']) {
        localStorage.setItem(REFRESH_TOKEN, res['refreshToken']);
      }
    }
    return true;
  }
  /**
   * Clears the tokens from the local storage
   * @returns {boolean}
   */
  refreshTokenRemover(): boolean {
    return this.clearStorage();
  }

  /**
   * Cleasr the tokens stored in the local storage
   */
  clearStorage(): boolean {
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
    return true;
  }

  /**
   * Defines the behaviour when errors occur
   * @returns {boolean}
   */
  catchError(err: any): boolean {
    // auto logout if 401 or 403 response returned from api
    if (err.status === 401 || err.status === 403) {
      this.sessionService.clearFirstTime();
      this.msalService.logout();
      // this.router.navigate(["/login"]);
    }
    return true;
  }

  /**
   * Returns the refresh token options
   */
  getRefreshTokenOpts() {
    return {
      endPoint: `${REFRESH_SERVICE}`,
      headers: [
        { Accept: '*/*' },
        { 'Cache-control': 'no-cache' },
        { 'Cache-control': 'no-store' },
        { Expires: '0' },
        { Pragma: 'no-cache' },
      ],
      ignorablePathList: [
        `${REFRESH_SERVICE}`,
        `${LOGIN_SERVICE}`,
        `${LOGOUT_SERVICE}`,
      ],
      payload: [],
      tokenName: 'refreshToken',
      offsetSeconds: 15, // 604740;
      tokenGetter: this.refreshTokenGetter.bind(this),
      tokenSetter: this.refreshTokenSetter.bind(this),
      tokenRemover: this.refreshTokenRemover.bind(this),
      catchError: this.catchError.bind(this),
    };
  }
}
